import React from "react";

const HeartFilled = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 23 21">
    <title>Selected Favorite Icon</title>
    <path
      fill="currentColor"
      d="M15.6476192,0.00545766191 C14.1629928,0.0629790907 12.7605407,0.6024792 11.6311957,1.51061283 L11.363613,1.737 L11.3200403,1.69667176 C10.1165207,0.614371834 8.56287225,5.32907052e-15 6.894812,5.32907052e-15 L6.65433502,0.00423844656 C3.22406832,0.125442255 0.518205185,2.83328589 0.0705936848,6.47295301 L0.0456129722,6.695 L0.0568588364,6.62147768 C-0.0468657903,7.24663498 -0.0226482836,8.14303136 0.246910661,9.25886657 C0.730351552,11.2620373 1.84249693,13.0765462 3.45163394,14.5021097 L10.3487642,20.6219939 C10.9131583,21.1227857 11.7617072,21.1263826 12.3303265,20.6303935 L19.3468832,14.5100673 C20.9648991,13.0763098 22.0768074,11.2621459 22.5603584,9.2585424 L22.6277889,8.96018478 C22.8123935,8.08184874 22.8402135,7.3550038 22.7759716,6.80286374 L22.7644683,6.72863201 C22.4063993,2.87510066 19.5367475,0.000332852546 15.9123788,0.000332852546 L15.6476192,0.00545766191 Z"
    ></path>
  </svg>
);

export default HeartFilled;
